import api from './api';
import { cache } from '../utils/cache';

export interface Shift {
  id: string;
  company_id: string;
  start_time: string;
  end_time?: string | null;
  status: 'open' | 'closed';
  opened_by: string; // user id
  opened_by_name?: string;
  closed_by?: string | null;
  closed_by_name?: string | null;
}

export interface ShiftSummary {
  total_sales: number;
  total_purchases: number;
  net_cash_flow: number;
  transactions_count: number;
  inventory_in_count: number;
  inventory_out_count: number;
}

export interface FinancialTransaction {
  id: string;
  type: 'sale' | 'purchase';
  amount: number;
  time: string;
}

export interface StockMovement {
  item_name: string;
  type: 'in' | 'out';
  quantity: number;
  reason?: string;
  time?: string;
}

export interface CurrentShiftResponse {
  shift: Shift | null;
  summary: ShiftSummary | null;
  transactions: FinancialTransaction[];
  stock_movements: StockMovement[];
}

export interface ShiftHistoryItem {
  id: string;
  start_time: string;
  end_time?: string | null;
  opened_by_name?: string;
  closed_by_name?: string | null;
  total_sales?: number;
  transactions_count?: number;
  status: 'open' | 'closed';
}

export const shiftService = {
  async getCurrent(): Promise<CurrentShiftResponse> {
    const response = await api.get<CurrentShiftResponse>('/shifts/current');
    return response.data;
  },

  async close(): Promise<{ shift: Shift }>{
    const response = await api.post<{ shift: Shift }>('/shifts/close', {});
    cache.invalidate('shifts');
    return response.data;
  },

  async getHistory(params?: { limit?: number; offset?: number }): Promise<ShiftHistoryItem[]> {
    const search = new URLSearchParams();
    if (params?.limit) search.append('limit', String(params.limit));
    if (params?.offset) search.append('offset', String(params.offset));
    const qs = search.toString();
    const key = `shifts_history_${qs || 'default'}`;
    
    return cache.fetch(key, async () => {
      const response = await api.get<ShiftHistoryItem[]>(`/shifts${qs ? `?${qs}` : ''}`);
      return response.data;
    });
  },
};

